import {Card, Box, Typography, Link} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {CTAProps} from '../type';
import {ChevronRight} from '@jobseeker/lotus/icons';

export default ({children, cardSxProps = {}, ...props}: CTAProps) => {
  return (
    <Card
      sx={{
        borderRadius: 4,
        position: 'relative',
        ...cardSxProps,
      }}
    >
      {props.cardInfo?.map((info, index) => {
        const showDivider = props?.cardInfo?.length
          ? index < props?.cardInfo?.length - 1
          : false;

        return (
          <>
            <Box
              key={`lotus-cta-v5-${index}`}
              data-testid={`lotus-cta-v5-${info?.title
                ?.toLowerCase()
                ?.replace(/ /g, '-')}`}
              p={2}
              sx={{
                borderBottom: showDivider
                  ? '1px solid rgba(126, 126, 126, 0.2)'
                  : '',
              }}
            >
              {info?.title && (
                <Box display={'flex'}>
                  <Typography
                    fontSize={12}
                    fontWeight="medium"
                    sx={{wordWrap: 'break-word'}}
                  >
                    {info?.title}
                  </Typography>
                  <Typography
                    fontSize={10}
                    color={'primary'}
                    fontWeight={'medium'}
                    borderRadius={'16px'}
                    height={'16px'}
                    border={'0.40px solid #49966E'}
                    px={1}
                    ml={0.5}
                  >
                    Active
                  </Typography>
                </Box>
              )}
              {info.actionLabel && info.actionUrl && (
                <Link
                  href={info.actionUrl}
                  target="_self"
                  sx={{
                    textDecoration: 'none',
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    mt: 0.25,
                  }}
                >
                  <Typography
                    fontSize={10}
                    color="secondary"
                    fontWeight="regular"
                  >
                    {info.actionLabel}
                  </Typography>
                  <Box component={'span'} sx={{mx: 0.25}}>
                    <Image
                      src={ChevronRight}
                      alt={'Arrow'}
                      width={10}
                      height={10}
                      objectFit="cover"
                    />
                  </Box>
                </Link>
              )}
            </Box>
          </>
        );
      })}
    </Card>
  );
};
